import type { UserMarkerVariant } from '@/types/mapData'

export interface MarkerVisual {
    glyph: string
    bg: string
    fg: string
    border: string
    dashed: boolean
    filled: boolean
}

// Single source of truth for how a UserMarkerVariant renders. Used by both the
// live mini-map markers on user cards and the on-screen legend, so the two can
// never drift apart.
export function getMarkerVisual(
    variant: UserMarkerVariant,
    movementIcon: string,
    userColor: string,
    warningColor: string
): MarkerVisual {
    switch (variant) {
        case 'moving':
            return {
                glyph: movementIcon,
                bg: userColor,
                fg: '#fff',
                border: userColor,
                dashed: false,
                filled: true,
            }
        case 'on_site':
            return {
                glyph: 'map-marker',
                bg: userColor,
                fg: '#fff',
                border: userColor,
                dashed: false,
                filled: true,
            }
        case 'idle':
            return {
                glyph: 'alert-circle',
                bg: 'transparent',
                fg: warningColor,
                border: warningColor,
                dashed: true,
                filled: false,
            }
        case 'off':
            return {
                glyph: movementIcon,
                bg: 'transparent',
                fg: userColor,
                border: userColor,
                dashed: false,
                filled: false,
            }
    }
}
